// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"39":"help","226":"password-reset","330":"profile-edit","784":"stats"}[chunkId] + "." + {"39":"e1aa4120","226":"6d5253eb","330":"b56cd4cc","784":"40ee2516"}[chunkId] + ".js";
};